export interface Timezone {
    iana: string
    offset: string
}

import data from './timezones.en.json' assert { type: 'json' }
export const timezonesEn = data as Timezone[]

export const byIana = Object.fromEntries(
    timezonesEn.map(t => [t.iana, t])
) as Record<string, Timezone>


